/* Udlært — personlig gravering v2 (2026-10-11). Hører til snippets/udlaert-gravering.liquid */
(() => {
  if (customElements.get('udl-gravering')) return;

  const ALLOWED = /^[A-Za-z0-9ÆØÅæøåÄÖÜäöüßÉéÈèÁáÓóÚúÍíÑñ .,:;&'’!?\/()+@#\-]*$/;
  const YS = { 1: [36.1], 2: [18.1, 54.1], 3: [12.6, 36.1, 59.6] };
  const MM = 300 / 91.74; /* preview-enheder pr. mm (udfoldet skilt 91,74 x 22,1 mm) */
  const PAY = '.shopify-payment-button, shopify-accelerated-checkout, [data-shopify="payment-button"]';
  let ctx;
  const measure = (txt, px) => {
    ctx = ctx || document.createElement('canvas').getContext('2d');
    ctx.font = `400 ${px}px Arial, Helvetica, sans-serif`;
    return ctx.measureText(txt).width;
  };
  const clean = (v) => v.normalize('NFC').replace(/[​-‍⁠﻿­]/g, '').replace(/[ \t\r\n]/g, ' ');
  const tidy = (v) => clean(v).replace(/ {2,}/g, ' ').trim();

  class UdlGravering extends HTMLElement {
    connectedCallback() {
      this.ac = new AbortController();
      const signal = this.ac.signal;
      this.uid = this.dataset.uid;
      this.formId = this.dataset.form;
      this.mode = this.dataset.mode;
      try { this.variants = JSON.parse(this.querySelector('[data-variants]').textContent); } catch (e) { this.variants = []; }
      try { this.t = JSON.parse(this.querySelector('[data-i18n]').textContent); } catch (e) { this.t = {}; }
      this.fonts = (this.dataset.fonts || '36,26,18').split(',').map(Number);
      this.maxw = Number(this.dataset.maxw) || 290;
      this.maxc = (this.dataset.maxc || '16,20,23').split(',').map(Number);
      this.skilt = (this.dataset.skilt || 'std16,prem24').split(',');
      this.touched = new Set();
      this.tried = false;
      this.active = null;

      const resync = () => { this.sync(); setTimeout(() => this.sync(), 150); };
      document.addEventListener('change', (e) => { if (this.ownsPicker(e.target)) resync(); }, { signal });
      document.addEventListener('variant:change', resync, { signal });
      window.addEventListener('pageshow', resync, { signal });
      document.addEventListener('submit', (e) => this.guard(e), { capture: true, signal });
      this.addEventListener('invalid', () => { if (!this.tried) { this.tried = true; this.render(); } }, { capture: true, signal });

      this.addEventListener('input', (e) => {
        const i = e.target;
        if (i.matches('[data-line] input')) {
          const c = clean(i.value);
          if (c !== i.value) i.value = c;
          this.touched.add(i);
          const ok = this.querySelector('[data-ok]');
          if (ok && ok.checked) ok.checked = false;
        }
        this.render();
      }, { signal });
      this.addEventListener('change', (e) => {
        const i = e.target;
        if (i.matches('[data-line] input')) { i.value = tidy(i.value); this.touched.add(i); }
        this.render();
      }, { signal });

      this.addEventListener('click', (e) => {
        if (!e.target.closest('[data-use-ex]')) return;
        const n = this.lines;
        const ex = this.exFor(n);
        this.querySelectorAll('[data-line]').forEach((row) => {
          const i = Number(row.dataset.line);
          const inp = row.querySelector('input');
          if (i <= n && ex[i - 1] && !tidy(inp.value)) { inp.value = ex[i - 1]; this.touched.add(inp); }
        });
        const ok = this.querySelector('[data-ok]'); if (ok) ok.checked = false;
        this.render();
        const first = this.querySelector('[data-line="1"] input'); if (first) first.focus();
      }, { signal });

      resync();
    }

    disconnectedCallback() { if (this.ac) this.ac.abort(); }

    exFor(n) {
      this._exc = this._exc || {};
      const fem = !!(this.variant && this.variant.f);
      const ck = n + (fem ? 'f' : 'm');
      if (this._exc[ck]) return this._exc[ck];
      const nm = this.t.nm || {};
      const swap = (s) => (fem && nm.m && nm.f ? s.replace(new RegExp('(^|\\s)' + nm.m + '(?=\\s|$)'), '$1' + nm.f) : s);
      const fs = this.fonts[n - 1] || 16;
      const cands = ((this.t.exc && this.t.exc[n]) || []).concat([(this.t.ex && this.t.ex[n]) || []]).map((set) => set.map(swap));
      const fit = cands.find((set) => set.length === n && set.every((s) => measure(s, fs) <= this.maxw * 0.97 && s.length <= (this.maxc[n - 1] || 99))) || cands[cands.length - 1];
      this._exc[ck] = fit;
      return fit;
    }

    get form() { return document.getElementById(this.formId); }
    get picker() { return document.getElementById('VariantPicker-' + this.uid); }
    get lines() {
      const r = this.querySelector('input[name="GravLines-' + this.uid + '"]:checked');
      return r ? Number(r.value) : 1;
    }

    ownsPicker(t) {
      if (!t || !t.closest) return false;
      const p = this.picker;
      if (p && p.contains(t)) return true;
      return !!(t.form && t.form.getAttribute('id') === this.formId && t.name === 'id');
    }

    selectedVariant() {
      const p = this.picker;
      if (p) {
        const vals = [...p.querySelectorAll('fieldset[data-option-index]')].map((fs) => {
          const r = fs.querySelector('input[type=radio]:checked');
          const s = fs.querySelector('select');
          return r ? r.value : (s ? s.value : null);
        });
        if (vals.length && vals.every((v) => v !== null)) {
          const hit = this.variants.find((x) => x.o.length === vals.length && x.o.every((o, i) => o === vals[i]));
          if (hit) return hit;
        }
      }
      const f = this.form;
      const idInput = f && f.querySelector('[name="id"]');
      const id = idInput ? Number(idInput.value) : NaN;
      return this.variants.find((x) => x.id === id) || null;
    }

    say(msg) {
      const l = this.querySelector('[data-live]');
      if (!l || !msg) return;
      l.textContent = '';
      setTimeout(() => { l.textContent = msg; }, 60);
    }

    scopes() {
      const s = [];
      if (this.form) s.push(this.form);
      const sec = this.closest('.shopify-section, section, dialog, [role="dialog"]');
      if (sec) s.push(sec);
      return s;
    }

    togglePay(show) {
      this.scopes().forEach((sc) => sc.querySelectorAll(PAY).forEach((el) => { el.style.display = show ? '' : 'none'; }));
    }

    toggleSubmit(enable, soldOut) {
      const f = this.form;
      if (!f) return;
      const btns = [...f.querySelectorAll('button[type="submit"], [name="add"]'), ...document.querySelectorAll(`[form="${this.formId}"][type="submit"]`)];
      btns.forEach((b) => {
        if (!enable) { if (!b.disabled) { b.disabled = true; b.dataset.udlOff = '1'; } }
        else if (b.dataset.udlOff) { delete b.dataset.udlOff; if (!soldOut) b.disabled = false; }
      });
    }

    sync() {
      const v = this.selectedVariant();
      this.variant = v;
      const on = !!(v && v.g);
      if (on !== this.active) {
        this.active = on;
        if (on && this.mode !== 'modal') this.say(this.t.live);
      }
      this.togglePay(!on);
      if (this.mode === 'modal') {
        const m = this.querySelector('[data-modal-msg]');
        if (m) m.hidden = !on;
        this.toggleSubmit(!on, !!(v && v.a === false));
        return;
      }
      const up = this.querySelector('[data-upsell]');
      if (up) up.hidden = on;
      const panel = this.querySelector('[data-panel]');
      if (panel) panel.hidden = !on;
      this.render();
    }

    render() {
      if (this.mode === 'modal' || !this.querySelector('[data-panel]')) return;
      const n = this.lines;
      const on = !!this.active;
      const fs = this.fonts[n - 1] || 16;
      const t = this.t;
      const lbl = this.querySelector('[data-lines-label]');
      if (lbl) lbl.textContent = n + ' ' + (n === 1 ? (t.line || '').toLowerCase() : t.lines);
      this.querySelectorAll('[data-example]').forEach((x) => { x.hidden = Number(x.dataset.example) !== n; });

      const vals = [];
      const over = [];
      this.querySelectorAll('[data-line]').forEach((row) => {
        const i = Number(row.dataset.line);
        const inp = row.querySelector('input');
        const err = row.querySelector('[data-err]');
        const fit = row.querySelector('[data-fit]');
        const use = i <= n;
        row.hidden = !use;
        inp.disabled = !(on && use);
        inp.required = on && use;
        const mc = this.maxc[n - 1] || 40;
        inp.maxLength = mc;
        if (!use) { inp.setCustomValidity(''); inp.removeAttribute('aria-invalid'); err.textContent = ''; fit.textContent = ''; return; }
        const exv = this.exFor(n)[i - 1] || '';
        if (exv) inp.placeholder = (t.fx || '') + exv;
        const v = tidy(inp.value);
        vals.push(v);
        let msg = '';
        let pct = 0;
        if (!v) msg = t.empty;
        else if ([...v].length > mc) msg = (t.long || '').replace('%M', mc);
        else if (!ALLOWED.test(v)) msg = t.chars;
        else {
          const w = measure(v, fs);
          pct = Math.round((w / this.maxw) * 100);
          if (w > this.maxw) { msg = t.wide; over.push(i); }
        }
        inp.setCustomValidity(on ? msg : '');
        const show = on && msg && (this.tried || (this.touched.has(inp) && v));
        err.textContent = show ? msg : '';
        if (show) inp.setAttribute('aria-invalid', 'true'); else inp.removeAttribute('aria-invalid');
        fit.textContent = `${[...v].length}/${mc} ${t.fit}`;
      });

      this.querySelectorAll('[data-pv]').forEach((el) => {
        const i = Number(el.dataset.pv);
        if (i > n) { el.textContent = ''; return; }
        el.setAttribute('font-size', fs);
        el.setAttribute('y', YS[n][i - 1]);
        const exv = this.exFor(n)[i - 1];
        el.textContent = vals[i - 1] || exv || `${t.line} ${i}`;
        el.setAttribute('fill-opacity', vals[i - 1] ? '1' : '.35');
        el.classList.toggle('is-over', over.includes(i));
      });

      const hLines = this.querySelector('[data-h-lines]');
      const hJson = this.querySelector('[data-h-json]');
      const hOk = this.querySelector('[data-h-ok]');
      const ok = this.querySelector('[data-ok]');
      hLines.disabled = !on;
      hJson.disabled = !on;
      hLines.value = n;
      hJson.value = JSON.stringify({
        v: 1,
        skilt: this.skilt[(this.variant && this.variant.s) || 0] || this.skilt[0],
        font: 'Arial-Regular',
        font_mm: Math.round((fs / MM) * 10) / 10,
        plade_mm: [91.7, 22.1],
        align: 'center',
        linjer: vals,
      });
      ok.disabled = !on;
      ok.required = on;
      if (on && ok.checked) {
        if (!hOk.value) hOk.value = 'Ja ' + new Date().toISOString();
        hOk.disabled = false;
      } else {
        hOk.value = '';
        hOk.disabled = true;
      }
    }

    guard(e) {
      if (!e.target || !e.target.getAttribute || e.target.getAttribute('id') !== this.formId) return;
      this.sync();
      const idIn = e.target.querySelector('[name="id"]');
      const sent = idIn ? this.variants.find((x) => x.id === Number(idIn.value)) : null;
      if (sent && sent.g && !this.active) {
        this.active = true;
        const p = this.querySelector('[data-panel]'); if (p) p.hidden = false;
        const u = this.querySelector('[data-upsell]'); if (u) u.hidden = true;
        this.render();
      }
      if (!this.active) return;
      if (this.mode === 'modal') {
        e.preventDefault();
        e.stopImmediatePropagation();
        const m = this.querySelector('[data-modal-msg]');
        if (m) m.hidden = false;
        return;
      }
      this.querySelectorAll('[data-line] input:not([disabled])').forEach((i) => { i.value = tidy(i.value); });
      this.tried = true;
      this.render();
      const bad = [...this.querySelectorAll('[data-line] input:not([disabled]), [data-ok]:not([disabled])')].find((i) => !i.checkValidity());
      if (bad) {
        e.preventDefault();
        e.stopImmediatePropagation();
        bad.focus({ preventScroll: false });
        if (bad.matches('[data-ok]')) bad.reportValidity();
      }
    }
  }

  customElements.define('udl-gravering', UdlGravering);
})();

/* Udlært — CVR i kurven (cart attribute "CVR") */
(() => {
  if (customElements.get('udl-cvr')) return;
  const norm = (v) => v.toUpperCase().replace(/[\s.\-]/g, '');
  const valid = (v) => !v || /^(DK)?\d{8}$/.test(v) || /^(?!DK)[A-Z]{2}[0-9A-Z]{2,12}$/.test(v);
  class UdlCvr extends HTMLElement {
    connectedCallback() {
      const inp = this.querySelector('[data-cvr]');
      const st = this.querySelector('[data-cvr-status]');
      if (!inp) return;
      let t;
      const save = () => {
        const v = norm(inp.value);
        const out = /^DK\d{8}$/.test(v) ? v.slice(2) : v;
        if (!valid(v)) { st.textContent = this.dataset.bad; st.style.color = '#b42318'; inp.setAttribute('aria-invalid', 'true'); return; }
        inp.removeAttribute('aria-invalid'); st.style.color = '';
        fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { CVR: out } })
        }).then((r) => { if (r.ok) st.textContent = out ? this.dataset.ok + ' ✓' : ''; }).catch(() => {});
      };
      inp.addEventListener('input', () => { clearTimeout(t); t = setTimeout(save, 600); });
      inp.addEventListener('change', save);
    }
  }
  customElements.define('udl-cvr', UdlCvr);
})();
